/**
 * TriggerBadge Component
 *
 * Visual indicator for job execution trigger source.
 */

import React from "react";
import type { EltJobExecutionTrigger } from "../../../types/elt-job-execution.types";
import { ClockIcon, HandRaisedIcon, CodeBracketIcon } from "@heroicons/react/24/outline";

interface TriggerBadgeProps {
  trigger: EltJobExecutionTrigger;
}

const triggerConfig: Record<EltJobExecutionTrigger, { label: string; icon: React.ReactNode; className: string }> = {
  schedule: {
    label: "Schedule",
    icon: <ClockIcon className="h-3.5 w-3.5" />,
    className: "bg-purple-100 text-purple-800",
  },
  manual: {
    label: "Manual",
    icon: <HandRaisedIcon className="h-3.5 w-3.5" />,
    className: "bg-primary-100 text-primary-800",
  },
  api: {
    label: "API",
    icon: <CodeBracketIcon className="h-3.5 w-3.5" />,
    className: "bg-cyan-100 text-cyan-800",
  },
};

const defaultConfig = {
  label: "Unknown",
  icon: null,
  className: "bg-gray-100 text-gray-800",
};

export const TriggerBadge: React.FC<TriggerBadgeProps> = ({ trigger }) => {
  const config = triggerConfig[trigger] || defaultConfig;

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${config.className}`}>
      {config.icon}
      {config.label}
    </span>
  );
};
